var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6118 9.39014C16.6177 10.392 17.6042 11.3841 18.615 12.3957C18.1776 12.8285 17.7305 13.2662 17.2835 13.7136C15.2182 15.7805 13.1481 17.8474 11.0877 19.9192C10.8738 20.1332 10.6212 20.1867 10.3587 20.2548C9.38685 20.4979 8.41982 20.7411 7.44793 20.9794C7.11262 21.0621 6.93768 20.8919 7.02029 20.566C7.28756 19.4669 7.55969 18.3727 7.83668 17.2784C7.86098 17.1909 7.91443 17.0985 7.97761 17.0304C10.5094 14.4918 13.046 11.9531 15.5827 9.41445C15.5924 9.395 15.6118 9.39014 15.6118 9.39014Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4957 11.4423C18.5141 10.46 17.5228 9.4727 16.5703 8.51949C16.9445 8.1207 17.3041 7.67327 17.7269 7.30852C18.2225 6.88055 19.0438 6.90487 19.5443 7.3377C19.9476 7.683 20.3267 8.06234 20.6717 8.47086C21.1188 8.99609 21.109 9.80827 20.6474 10.3238C20.2878 10.7177 19.8747 11.0727 19.4957 11.4423Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEditIcon);
export default __webpack_public_path__ + "static/media/Image-Edit-Icon.3ea07a628eec92294cf105699d9e24ec.svg";
export { ForwardRef as ReactComponent };